<template>
  <b-navbar sticky type="dark" variant="info" class="w-100 m-0 p-1 shadow">
    <b-container fluid>
      <b-row class="w-100">
        <b-col sm="12" md="6" order-sm="2">
          <b-navbar-brand href="/" class="text-right w-100">پنل مدیریتی مشکات</b-navbar-brand>
        </b-col>
        <b-col sm="12" md="6" order-sm="1">
          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>
            <b-button variant="outline-danger" class="mx-1" @click="doLogout">
              <b-icon icon="power"></b-icon> خروج
            </b-button>
            <b-button variant="outline-light" class="mx-1" @click="showAccountModal = true">
              <b-icon icon="person-fill"></b-icon> حساب کاربری
            </b-button>
            <b-modal
              v-model="showAccountModal"
              title="حساب کاربری"
              header-bg-variant="info"
              header-text-variant="light"
              :ok-only="true"
              ok-variant="info"
              ok-title="باشه"
              @shown="accountModalShown"
            >
              <b-overlay
                :show="loadingAccountModal"
                rounded
                opacity="0.6"
                spinner-large
                spinner-variant="info"
                class="d-inline-block w-100"
                @hidden="!loadingAccountModal"
              >
                <b-row class="m-3">
                  <b-col class="text-right" md="12">
                    <p class="font-weight-bold">نام کاربری</p>
                    <p class="font-weight-lighter text-left">{{ meUser.username }}</p>
                    <p class="font-weight-bold">ایمیل</p>
                    <p class="font-weight-lighter text-left">{{ meUser.email }}</p>
                    <p class="font-weight-bold">تلفن همراه</p>
                    <p class="font-weight-lighter text-left">{{ meUser.mobile_number }}</p>
                    <p class="font-weight-bold">سطح دسترسی</p>
                    <p class="font-weight-lighter">{{ meUser.group_slog }}</p>
                  </b-col>
                  <b-col class="text-center" md="12">
                    <b-button variant="outline-info" size="sm" class="mt-1" href="https://meshkat.resalatuniversity.ir/users/account">
                      <b-icon icon="box-arrow-up-right" class="m-1"></b-icon>مشاهده و ویرایش حساب کاربری در نمایه
                    </b-button>
                  </b-col>
                </b-row>
              </b-overlay>
            </b-modal>
          </b-collapse>
        </b-col>
      </b-row>
    </b-container>
  </b-navbar>
</template>
<script>
export default {
  name: 'TopBarMenu',
  data: () => ({
    showAccountModal: false,
    loadingAccountModal: false,
    meUser: {
      username: '',
      email: '',
      mobile_number: '',
      group_slog: ''
    }
  }),
  methods: {
    doLogout() {
      this.$store.commit('setFetchDataParamsState', null)
      this.$store.commit('logout')
      this.$router.replace({ name: 'LoginRegister' })
    },
    accountModalShown() {
      this.loadingAccountModal = true
      this.$axios.get('/users/me').then((response) => {
        const body = response.data

        this.meUser.username = body.data.username || '-'
        this.meUser.email = body.data.email || '-'
        this.meUser.mobile_number = body.data.mobile_number || '-'
        this.meUser.group_slog = body.data.group.slog || '-'
      }).catch(err => {
        this.$bvToast.toast(err.text, { variant: 'danger', title: 'خطا' })
      }).finally(() => {
        this.loadingAccountModal = false
      })
    }
  }
}
</script>